import { Drawer, IconButton, Stack, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import { useTranslation } from "../../../../hooks/useTranslation";
import { FilterGroup1 } from "./filter-groups/FilterGroup1";

type FilterDrawerProps = {
  open: boolean;
  onClose: () => void;
};

export const FilterDrawer = (props: FilterDrawerProps) => {
  const { open, onClose } = props;
  const { translate } = useTranslation(
    "pages.inventoryManagement.inventory.list.filters",
  );

  return (
    <Drawer open={open} onClose={onClose} anchor="right">
      <Stack
        sx={{ height: "100%", maxHeight: "100vh" }}
        direction="column"
        spacing={2}
        px={2}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          p={2}
        >
          <Typography variant="h6">{translate("title")}</Typography>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </Stack>
        <Stack flex="1" sx={{ overflowY: "scroll" }}>
          <FilterGroup1 />
        </Stack>
      </Stack>
    </Drawer>
  );
};
